/**
 * Theme constants to eliminate magic strings
 */

export const THEMES = {
  LIGHT: 'light',
  DARK: 'dark',
  // Future themes can be added here
  OCEAN: 'ocean',
  FOREST: 'forest',
  SUNSET: 'sunset',
  MONOCHROME: 'monochrome',
  HIGH_CONTRAST: 'high_contrast',
};

export const THEME_NAMES = Object.values(THEMES);

export const DEFAULT_THEME = THEMES.LIGHT;

export const THEME_STORAGE_KEY = 'plotwyze-theme';

/**
 * Theme metadata for UI display
 */
export const THEME_METADATA = {
  [THEMES.LIGHT]: {
    name: 'Light',
    description: 'Clean and bright interface',
    icon: '☀️',
  },
  [THEMES.DARK]: {
    name: 'Dark',
    description: 'Easy on the eyes',
    icon: '🌙',
  },
  [THEMES.OCEAN]: {
    name: 'Ocean',
    description: 'Calming blue tones',
    icon: '🌊',
  },
  [THEMES.FOREST]: {
    name: 'Forest',
    description: 'Natural green palette',
    icon: '🌲',
  },
  [THEMES.SUNSET]: {
    name: 'Sunset',
    description: 'Warm orange and pink',
    icon: '🌅',
  },
  [THEMES.MONOCHROME]: {
    name: 'Monochrome',
    description: 'Pure black and white',
    icon: '⚫',
  },
  [THEMES.HIGH_CONTRAST]: {
    name: 'High Contrast',
    description: 'Maximum accessibility',
    icon: '🔲',
  },
};

/**
 * Color role constants
 */
export const COLOR_ROLES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  INFO: 'info',
  NEUTRAL: 'neutral',
  SURFACE: 'surface',
  BACKGROUND: 'background',
  TEXT: 'text',
  BORDER: 'border',
  HOVER: 'hover',
  FOCUS: 'focus',
  DISABLED: 'disabled',
};

/**
 * Shade constants
 */
export const SHADES = {
  LIGHTEST: 0,
  LIGHTER: 10,
  LIGHT: 20,
  MEDIUM_LIGHT: 30,
  MEDIUM: 40,
  MEDIUM_DARK: 50,
  DARK: 60,
  DARKER: 70,
  DARKEST: 80,
  DEEP: 90,
  MAX: 100,
};
